<div *transloco="let t">
  <tabset *ngIf="tabs" #staticTabs>
    <tab *ngFor="let tab of tabs" [disabled]="tab.disabled" [active]="tab.active" [heading]="tab.translationKey ?  t(tab.translationKey) : tab.preTranslatedText ? tab.preTranslatedText : ''" id="{{tab.id}}" (selectTab)="onSelect(tab,$event)">{{tab.content}}</tab>
  </tabset>
</div>